module.exports = __webpack_public_path__ + "media/icons/key-r-7a01c5d2.svg";